import LinksTracker from './linkstracker';
import lazyframe from 'lazyframe';

class Global {
  constructor(options) {
    var defaults = {};
    this.params = Object.assign({}, defaults, options || {});
    this.run();
  }

  run() {
    this.contactForm();
    // this.menu();
    new LinksTracker();
    this.sharingTools();
    this.lazyLoadVideos();
	this.setMenuTogglers();
  }

  contactForm() {
    var contactForm = document.getElementById('main-contact-form');
    if (contactForm) {
      var inputs = contactForm.querySelectorAll('.animate-label');
      inputs.forEach((input, index) => {
        input.addEventListener('focus', function () {
          this.parentNode.classList.add('focusin');
        }, true);
        input.addEventListener('blur', function () {
          if (!this.value) {
            this.parentNode.classList.remove('focusin');
          }
        }, true);
      });
    }
  }

  menu() {
    var menu = document.getElementById('main-menu');
    if (menu) {
      var togglers = menu.querySelectorAll('.level-1');
      var submenus = [];
      togglers.forEach((toggler, index) => {
        toggler.addEventListener('mouseover', function (event) {
          event.preventDefault();
          this.parentElement.classList.toggle('opened');
        }, true);
      });
    }
  }

  setMenuTogglers() {

	let menuContainer = document.querySelector('#main-menu');
	if (menuContainer) {
		let listTogglers = menuContainer.querySelectorAll('.toggle-link');

		if (listTogglers.length) {
			listTogglers.forEach((toggler, index) => {
				toggler.addEventListener('click', function () {
				this.parentNode.classList.toggle('submenu-visible');
				}, true);
			});
		}
	}
  }

  sharingTools() {
    window.shareToMessenger = this.shareToMessenger;
    window.isMobile = this.isMobile;
    window.copyItemUrl = this.copyItemUrl;
  }

  shareToMessenger(url) {
    if (window.isMobile()) {
      window.location.href = 'fb-messenger://share/?app_id=1725610871097937&link=' + url;
    } else {
      window.open('https://www.facebook.com/dialog/send?app_id=1725610871097937&link=' + url + '&redirect_uri=' + url, '_blank');
    }
  }

  isMobile() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent)) {
      return true;
    }

    if (/android/i.test(userAgent)) {
      return true;
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return true;
    }

    return false;
  }

  copyItemUrl(element) {

    if (!navigator.clipboard) {
      return;
    }

    const url = element.dataset.url;

    if (!url) {
      return;
    }

    navigator.clipboard.writeText(url).then(
      () => {
        element.classList.add('copied');
        window.setTimeout(() => {
          element.classList.remove('copied');
        }, 5000);

      }, () => {
        console.log('Copy URL failed');
      }
    );

  }

  lazyLoadVideos() {
    lazyframe('.lazyframe', {
      autoplay: true
    });
  }

}



export {
  Global as
    default
};
